import React, { useRef, useState, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom'; // Import useNavigate
import ArtPage from './ArtPage';
import { tagColor } from './TagsInput.js';

const ArtThumbnail = ({ art, displayCheckmark = true, displayTag = false }) => {
  const navigate = useNavigate(); // Initialize navigate
  const [selected, setSelected] = useState(false);
  const modalRef = useRef(null);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const isMobile = window.innerWidth <= 768; // Check screen size for mobile

  const preventDefault = useCallback((e) => {
    if (e.cancelable) {
      e.preventDefault();
    }
  }, []);

  const handleTouchStart = (e) => {
    setIsDragging(true);
    const rect = modalRef.current.getBoundingClientRect();
    setDragOffset({
      x: e.touches[0].clientX - rect.left,
      y: e.touches[0].clientY - rect.top,
    });
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const modal = modalRef.current;
    const deltaX = e.touches[0].clientX - dragOffset.x;
    const deltaY = e.touches[0].clientY - dragOffset.y;
    if (deltaX < 0) {
      return; // Prevent dragging to the left
    }
    if (dragOffset.x <= 30) {
      return; // Prevent simultaneous dragging and history back
    }

    // Disable scrolling of parent.
    document.body.style.overflow = 'hidden';

    // Enable drag only if deltaX > deltaY
    if (Math.abs(deltaX) > Math.abs(deltaY)) {
      // Disable scrolling.
      modal.style.overflow = 'hidden';
      modal.addEventListener('touchmove', preventDefault, { passive: false });

      // Apply transform with smooth transition
    //   modal.style.transition = 'transform 0.1s ease-out';
    //   modal.style.transition = 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
      modal.style.transform = `translate(${deltaX}px, 0)`;

      // Reduce width and height proportionally, scale more slowly
      const scale = 1 - Math.min(deltaX / (window.innerWidth * 2), 0.20); // Limit reduction to 10%
    //   modal.style.transform += ` scale(${scale})`;

    //   // Enable vertical drag after horizontal drag
    //   if (Math.abs(deltaX) > 70) {
    //     // modal.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(${scale})`;
    //     modal.style.transform = `translate(${deltaX}px, ${deltaY}px)`;
    //   }
    }
  };

  const handleTouchEnd = () => {
    setIsDragging(false);

    // Enable scrolling again.
    document.body.style.overflow = 'auto';
    modalRef.current.style.overflow = 'auto';
    modalRef.current.removeEventListener('touchmove', preventDefault);

    const rect = modalRef.current.getBoundingClientRect();
    const modalWidth = rect.width;

    // Close modal if dragged to the right by at least 20% of its width
    if (rect.left - dragOffset.x > modalWidth / 5) {
      setSelected(false);
    //   window.history.back(); // Go back to the previous page
    } else {
      // Reset position if not dragged far enough
    //   modalRef.current.style.transition = 'transform 0.3s ease-out';
      modalRef.current.style.transform = "translate(0, 0)";
    }
  };

  return (
    <>
      <div className="relative">
        <img
          src={art.thumbnailUrl}
          alt="Thumbnail"
          className="w-full h-auto object-cover cursor-pointer block"
        />
        {displayTag && art.myEventTagName && (
          <div
            className={`absolute bottom-2 right-2 font-bold text-lg text-center overflow-hidden whitespace-nowrap truncate ${tagColor(art.myEventTagName, true, undefined, 0)}`}
          >
            {"#"}
          </div>
        )}
        {(displayCheckmark && art.myEventIsFinished) && (
          <div className="absolute bottom-2 right-2 rounded-full p-1" style={{ backgroundColor: 'var(--mantine-color-body)' }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-green-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
        )}
      </div>
    </>
  );
};

export default ArtThumbnail;
